import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';

import * as ElementActions from "../../data/elements/ElementActions";

import ElementPropertiesSidebar from "./ElementPropertiesSidebar";

const mapStateToProps = (state, ownProps) => ({
    media: _.filter(state.media, ['accountId', state.currentAccountId]),
});

const mapDispatchToProps = {
    onChanged: ElementActions.elementChanged,
    onChanging: ElementActions.elementChanging,

    removeElement: ElementActions.removeElement,

    bringElementForward: ElementActions.bringElementForward,
    sendElementBackward: ElementActions.sendElementBackward,
    bringElementToFront: ElementActions.bringElementToFront,
    sendElementToBack: ElementActions.sendElementToBack,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ElementPropertiesSidebar);
